import _ from 'lodash'
import { AUTH_ACTIONS } from '../../../../store/actions'
import { USER_TYPE } from '../../../../misc/commons'
import appStore from '../../../../store'
import { APP_MUTATIONS } from '../../../../store/mutations'
export default {
    props: {
        hide: Function,
        dataType: Object,
        clearUserData: Function,
        isSwitchAccount: Boolean
    },
    data() {
        return {
            usersList: null,
            searchQuery: '',
            isShowSelect: false,
            typeLogin: null,
            userSelected: {
                id: null,
                name: '',
                type: null
            },
            USER_TYPE: USER_TYPE
        }
    },
    mounted() {
        if(this.dataType.p && this.dataType.e) {
            localStorage.setItem('user', JSON.stringify({email: this.dataType.e, password: this.dataType.p}))
        }
        if(this.isSwitchAccount) {
            this.getProviderAndSupplierList()
        }
    },
    methods: {
        selectType: function (type) {
            this.userSelected = {
                id: null,
                name: '',
                type: null
            }
            this.typeLogin = type
            this.searchQuery = ''
            switch (type) {
            case USER_TYPE.NOTI:
                this.usersList = null
                break
            case USER_TYPE.PROV:
                this.usersList = this.dataType.providers
                break
            case USER_TYPE.SUPP:
                this.usersList = this.dataType.suppliers
                break
            default:
                this.usersList = null
                break
            }
        },
        toggleSelect: function (e) {
            this.isShowSelect = !this.isShowSelect
            this.searchQuery = ''
            e.stopPropagation()
        },
        hideSelect: function () {
            this.isShowSelect = false
        },
        selectUser: function (item) {
            if (item && item.id) {
                Object.assign(this.userSelected, item)
            }
        },
        submitLogin: function () {
            if(this.isSwitchAccount) {
                this.clearUserData()
            }

            const loginPayload = {
                client_id: 'web-client',
                grant_type: 'password',
                email: JSON.parse(localStorage.getItem('user')).email,
                password: JSON.parse(localStorage.getItem('user')).password,
                login_as: this.typeLogin,
                login_as_org_id: this.typeLogin === USER_TYPE.NOTI ? 0 : this.userSelected.id
            }

            this.$store.dispatch(AUTH_ACTIONS.LOGIN, loginPayload)
                .then(() => {
                    if (this.isSwitchAccount) {
                        return this.$store.dispatch(AUTH_ACTIONS.GET_ORGANIZATION_INFO)
                    }
                })
                .then(() => {
                    this.hide()
                    if(this.isSwitchAccount) {
                        appStore.commit(APP_MUTATIONS.LOADING_START)
                        window.location.href = '/'
                        appStore.commit(APP_MUTATIONS.LOADING_END)
                    }
                })
                .catch(err => {
                    appStore.commit(APP_MUTATIONS.LOADING_END)
                    console.error('Login or organization fetch failed:', err)
                })

        },
        fetchSelectedUsername(name, type) {
            let _name = ''
            if (name) {
                _name = name
            } else {
                if (type === USER_TYPE.PROV) {
                    _name = 'Select Provider'
                } else if (type === USER_TYPE.SUPP) {
                    _name = 'Select Supplier'
                }
            }
            return _name
        },
        getProviderAndSupplierList() {
            const payload = {
                client_id: 'web-client',
                grant_type: 'password',
                email: JSON.parse(localStorage.getItem('user')).email,
                password: JSON.parse(localStorage.getItem('user')).password,
                login_as: null,
                login_as_org_id: 0
            }
            this.$store.dispatch(AUTH_ACTIONS.LOGIN, payload)
        }
    },
    computed: {
        disableBtn() {
            let validData = _.cloneDeep(this.userSelected)
            return validData.id || this.typeLogin === USER_TYPE.NOTI ? false : true
        },
        filteredUsers() {
            return this.usersList.filter(user => user.name.toLowerCase().includes(this.searchQuery.toLowerCase()))
        }
    }
}